export default "__VITE_ASSET__CabnSUf6__"